import { useCallback, useEffect, useState } from 'react'
import { VideoPlayerWithPlugins } from 'data/VideoPlayer'

const useVideoMuted = (player: VideoPlayerWithPlugins | null) => {
    const [videoMuted, setVideoMuted] = useState(false)

    useEffect(() => {
        if (player) {
            player.on('volumechange', () => {
                const playerMuted = player.muted()
                if (videoMuted !== playerMuted) setVideoMuted(playerMuted)
            })
        }
    }, [player, videoMuted])

    const setMuted = useCallback(
        (muted: boolean) => {
            if (player) player.muted(muted)
            setVideoMuted(muted)
        },
        [player, setVideoMuted],
    )

    return [videoMuted, setMuted]
}

export default useVideoMuted
